import React from 'react';
import { PhoneOutlined, MessageOutlined, LockOutlined } from '@ant-design/icons';

const CampaignTypeStep: React.FC = () => {
	return (
		<div className="w-full flex flex-col items-center justify-center py-6">
			<h2 className="text-xl font-semibold mb-6 text-center text-gray-800">
				Select Outbound Task Type
			</h2>
			<div className="grid grid-cols-3 gap-4 w-full max-w-lg mx-auto">
				<div className="h-28 flex flex-col items-center justify-center border-2 rounded-lg border-blue-500 bg-blue-50 shadow-sm">
					<PhoneOutlined className="text-2xl mb-2 text-blue-500" />
					<span className="text-base font-medium text-gray-800">Calling</span>
				</div>

				<div className="h-28 flex flex-col items-center justify-center border-2 rounded-lg bg-gray-50 border-gray-200 relative cursor-not-allowed">
					<div className="absolute top-2 right-2">
						<LockOutlined className="text-gray-400 text-sm" />
					</div>
					<MessageOutlined className="text-2xl mb-2 text-gray-400" />
					<span className="text-base font-medium text-gray-400">Texting</span>
					<span className="text-xs text-gray-400 mt-1">Coming Soon</span>
				</div>

				<div className="h-28 flex flex-col items-center justify-center border-2 rounded-lg bg-gray-50 border-gray-200 relative cursor-not-allowed">
					<div className="absolute top-2 right-2">
						<LockOutlined className="text-gray-400 text-sm" />
					</div>
					<div className="flex gap-1 text-2xl mb-2 text-gray-400">
						<PhoneOutlined />
						<MessageOutlined />
					</div>
					<span className="text-base font-medium text-gray-400">Both</span>
					<span className="text-xs text-gray-400 mt-1">Coming Soon</span>
				</div>
			</div>
		</div>
	);
};

export default CampaignTypeStep;
